<template>
  <div class="col-12 pg-login">
    <div class="form-login col-12 row col-md-4 px-0">
      <form class="mb-1" @submit.prevent="login">
        <div class="col-12 d-flex justify-content-center my-4">
          <img alt="Akdemica logo" height="100" src="../../assets/img/logo-completa.png">
        </div>

        <div class="row col-12 m-0 p-0">
          <div class="col-12 mt-2">
            <label><small>Email</small></label>
            <input
              v-model="form.email"
              class="form-control"
              type="email"
              :class="{ 'is-invalid': form.errors.has('email') }"
            />
            <has-error :form="form" field="email"></has-error>
          </div>

          <div class="col-12 mt-2">
            <label><small>Senha</small></label>
            <input
              v-model="password"
              class="form-control"
              type="password"
              :class="{ 'is-invalid': form.errors.has('password') }"
            />
            <has-error :form="form" field="password"></has-error>
          </div>

          <div class="col-12 mt-2">
            <button class="btn btn-success form-control"><b>Entrar</b></button>
          </div>

          <div class="col-12 mt-1">
            <a href="/register" class="btn btn-dark form-control"><b>Registrar-se</b></a>
          </div>
        </div>
      </form>

      <p class="text-center mb-1 col-12">- ou -</p>

      <div class="col-12 col-md-6 mb-1">
        <a
          class="btn btn-sm btn-dark form-control"
          :href="`${ apiHost }/provider?provider=facebook`"
        >
          <i class="fab fa-facebook-f"></i>&nbsp;<b>Entrar com Facebook</b>
        </a>
      </div>

      <div class="col-12 col-md-6 mb-1">
        <a
          class="btn btn-sm btn-dark form-control"
          :href="`${ apiHost }/provider?provider=google`"
        >
          <i class="fab fa-google"></i>&nbsp;<b>Entrar com Google</b>
        </a>
      </div>
    <!-- Inicio parte comentada
      <div class="col-12 col-md-6 mb-1">
        <a
          class="btn btn-sm btn-info form-control"
          :href="`${ apiHost }/provider?provider=linkedin`"
        >
          <i class="fab fa-linkedin"></i>&nbsp;<b>Entrar com LinkedIn</b>
        </a>
      </div>

      <div class="col-12 col-md-6">
        <a
          class="btn btn-sm btn-dark form-control"
          :href="`${ apiHost }/provider?provider=github`"
        >
          <i class="fab fa-github"></i>&nbsp;<b>Entrar com GitHub</b>
        </a>
      </div>

      Fim Parte comentada -->

      <p class="text-center mt-3 mb-1 col-12">
        <a href="/reset">Esqueci a minha senha.</a>
      </p>

    </div>
  </div>
</template>

<script>
import Form from 'vform'
import hash from 'hash.js'
import { mapActions } from 'vuex'
import Axios from 'axios'
import { getCookie, setCookie } from '@/cookiesHandler'

export default {
  data () {
    return {
      password: undefined,
      form: new Form({
        email: undefined,
        password: undefined,
      }),
      apiHost: process.env.VUE_APP_ROOT_BASE
    }
  },
  methods: {
    ...mapActions({
      setLoginTrue: 'login'
    }),

    loginSocial: function ( data ) {
      // 100 - Sucesso
      // Error 101 - Email já esta cadastrado em outra conta Social.
      // Error 102 - Email já esta cadastrado.
      // Error 103 - Algo deu Erro, tente novamente.
      if ( data.code === '100' ) {
        let json = JSON.parse( data.c )
        this.registerLoginData( json )
      } else if ( data.code === '101' ) {
          this.form.errors.set('password', 'Email já esta cadastrado em outra conta Social.')
      } else if ( data.code === '102' ) {
        this.form.errors.set('password', 'Email já esta cadastrado.')
      } else if ( data.code === '103' ) {
        this.form.errors.set('password', 'Algo deu Erro, tente novamente.')
      } else if ( data.code === '104' ) {
        this.form.errors.set('password', 'Operação cancelada.')
      }

    },

    registerLoginData: function ( data ) {
      setCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00', data.token, 1)
      this.$store.commit('LOGIN_USER')
      this.$store.commit('SET_CURRENT_USER', data.info)
      Axios.defaults.headers.common['Authorization'] = `Bearer ${ getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00') }`

      if ( this.$route.query.redirect ) {
        this.$router.push( this.$route.query.redirect )
      } else {
        this.$router.push('/painel')
      }
    },

    login: function () {
      this.form.password = hash.sha256().update( this.password ).digest('hex')

      this.form.post('/auth/login')
        .then( res => {
          this.registerLoginData( res.data )
        })
        .catch ( err => {
          this.form.errors.set('password', 'Usuário ou senha Incorretos.')
          // console.error('erro', err)
        })
    }
  },
  mounted () {
    if ( this.$route.query.cid && this.$route.query.cid.length ===  36 ) {
      this.loginSocial( this.$route.query )
    }
  }
}
</script>
